import {useMemo} from 'react';
import {parseActions} from '@netx/core-next/utils';
import {useConstCallback} from '@netx/core-components/hooks/useConstCallback';
import {
	searchSavedActionAddToCurrentCart,
	searchSavedActionCreatePDF,
	searchSavedActionDelete,
	searchSavedActionDownload,
	searchSavedActionRename,
	searchSavedActionShareMenu,
	searchSavedActionToggleFavorite,
	searchSavedActionView,
} from '../actions';
import type {SavedSearch} from '../types';
import {useSavedSearch} from './useSavedSearch';

export type UseSavedSearchActionsArguments = {
	id?: number;
	order?: boolean;
	omit?: string[];
	pick?: string[];
};

export const useSavedSearchActions = ({
	id,
	...props
}: UseSavedSearchActionsArguments = {}) => {
	const {savedSearch, loading} = useSavedSearch({id});

	const getActions = useConstCallback(
		({
			savedSearch,
			pick,
			omit,
			order,
		}: Omit<UseSavedSearchActionsArguments, 'id'> & {
			savedSearch?: SavedSearch;
		} = {}) => {
			return !savedSearch
				? []
				: parseActions({
						actions: [
							searchSavedActionAddToCurrentCart(savedSearch, {group: 1}),

							searchSavedActionDownload(savedSearch, {group: 2}),
							searchSavedActionView(savedSearch, {group: 2}),
							searchSavedActionCreatePDF(savedSearch, {group: 2}),
							searchSavedActionShareMenu(savedSearch, {group: 2}),
							searchSavedActionRename(savedSearch, {group: 2}),
							searchSavedActionToggleFavorite(savedSearch, {group: 2}),

							searchSavedActionDelete(savedSearch, {group: 3}),
						],
						order,
						omit,
						pick,
				  });
		},
	);

	const actions = useMemo(
		() => getActions({savedSearch, ...props}),
		[savedSearch, props],
	);

	return {
		actions,
		getActions,
		loading,
	};
};

export default useSavedSearchActions;
